<div class="home-bg app-container landing-page" [ngClass]="{ 'h-100' : !commonService.showMenubar()}">
    <div class="row m-0">
        <div class="col-md-2 p-0"></div>
        <div class="col-md-3 col-sm-12 p-0">
            <img class="mob-outlive-logo" [src]="commonService.resource.image.outlive_chat" alt="">
        </div>
        <div class="col-md-7 p-0"></div>
    </div>
    <img class="bg-line onboard-bg-line mobile-show position-fixed" [src]="commonService.resource.image.onboard_bg_line" alt="">
    <img class="bg-line mobile-hide position-fixed w-100" style="bottom: 0px" [src]="commonService.resource.image.landing_page_line" alt="">
    <div class="content-container landing-page-container">
        <div class="row m-0">
            <div class="col-md-2 p-0"></div>
            <div class="col-md-3 col-sm-12 p-0">
                <div id="slider" class="carousel slide" data-bs-ride="carousel" data-bs-touch="true">
                    <div class="carousel-inner">
                        <ng-container *ngFor="let slide of commonService.resource.image.landing_page_slide;let i=index">
                            <div class="carousel-item" [ngClass]="{'active': i === 0}">
                                <div class="app-heading landing-header d-block mt-5" [innerHTML]="('setLanguage.slide' + (i+1)+ '.title' | translate)">
                                </div>
                                <div class="subcontent py-4 font-15">
                                    {{ 'setLanguage.slide' + (i+1)+ '.content' | translate}}
                                </div>
                                <div class="slide-icons">
                                    <img [src]="slide.icon" width="30" alt="">
                                </div>
                            </div>
                        </ng-container>
                    </div>
                    <div class="carousel-indicators position-relative">
                        <button type="button" data-bs-target="#slider" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                        <button type="button" data-bs-target="#slider" data-bs-slide-to="1" aria-label="Slide 2"></button>
                        <button type="button" data-bs-target="#slider" data-bs-slide-to="2" aria-label="Slide 3"></button>
                        <button type="button" data-bs-target="#slider" data-bs-slide-to="3" aria-label="Slide 4"></button>
                        <button type="button" data-bs-target="#slider" data-bs-slide-to="4" aria-label="Slide 5"></button>
                    </div>
                </div>
                <div class="d-flex justify-content-between gap-3">
                    <button mat-button class="landing-page-btn" [ngClass]="{ 'active': language === 'en' }" (click)="setLanguage('en')">
                        {{ 'setLanguage.language1' | translate}}
                    </button>
                    <button mat-button class="landing-page-btn" [ngClass]="{ 'active': language === 'ma' }" (click)="setLanguage('ma')">
                        {{ 'setLanguage.language2' | translate}}
                    </button>
                    <button mat-button class="landing-page-btn" [ngClass]="{ 'active': language === 'hi' }" (click)="setLanguage('hi')">
                        {{ 'setLanguage.language3' | translate}}
                    </button>
                </div>
                <div class="py-5">
                    <button mat-button class="primary-button w-100" (click)="commonService.saveLanguage(language, '/policy-disclaimer')">
                        {{ 'setLanguage.setLanguageBtn' | translate}}
                    </button>
                </div>
            </div>
        </div>
        <div class="col-5 position-relative">
        </div>
        <div class="col-2"></div>
    </div>
</div>